import React from "react";
import moment from "moment";
import { STAGES, STAGE_TONES } from "../config/stages";

const formatDate = function (value) {
  const when = value ? moment(value) : null;
  return when && when.isValid() ? when.format("DD MMM YYYY") : undefined;
};

/*
Brief fields read straight off GET /ticket/{id}/ - device.brand.name,
device.name, type_label, retailer and due_date all come back on that response.
*/
const briefFields = function (ticket) {
  if (!ticket) return [];
  const device = ticket.user_device && ticket.user_device.device;
  return [
    { label: "Brand", value: device && device.brand && device.brand.name },
    { label: "Product", value: device && device.name },
    { label: "Service Type", value: ticket.type_label },
    { label: "Retailer", value: ticket.retailer },
    { label: "Due Date", value: formatDate(ticket.due_date) },
  ];
};

// Left rail: status plus the fixed case attributes.
export const BriefCard = function (props) {
  const { stage, outcome, ticket } = props;
  const current = STAGES[stage];
  const tone = (current && STAGE_TONES[current.key]) || {
    bg: "#eef0f3",
    fg: "#64748b",
  };
  const isComplete = current && current.key === "complete";

  return (
    <aside className="tn-card tn-brief">
      <div className="tn-card-body">
        <div className="tn-eyebrow tn-brief-eyebrow">Brief</div>

        <div className="tn-brief-field">
          <div className="tn-brief-label">Status</div>
          <span
            className="tn-badge tn-badge-dot tn-brief-status"
            style={{ background: tone.bg, color: tone.fg }}
          >
            <span className="tn-badge-dotmark" />
            {isComplete && outcome
              ? "Complete · " + outcome
              : (ticket && (ticket.status_label || ticket.status)) ||
                current.label}
          </span>
        </div>

        <div className="tn-brief-divider" />

        {briefFields(ticket).map(function (item) {
          return (
            <div className="tn-brief-field" key={item.label}>
              <div className="tn-brief-label">{item.label}</div>
              <div className="tn-brief-value">{item.value || "—"}</div>
            </div>
          );
        })}
      </div>
    </aside>
  );
};

export default { BriefCard };
